import {
  calculateFlatDiscount,
  calculatePercentageDiscount,
} from "../../discountCommons/index.js";
import { findApplicableContainerDiscounts } from "../findApplicableContainerDiscounts/index.js";
import type { SupplierRetailerConnectionDiscountItemType } from "../supplierRetailerConnectionDiscountCommons.js";

export const findBiggestContainerDiscount = ({
  connectionDiscounts,
  product,
}: {
  connectionDiscounts: {
    deletedAt: Date | null;
    discountAmount: number;
    type: "flat" | "percentage";
    itemType: SupplierRetailerConnectionDiscountItemType | null;
  }[];
  product: {
    containerType: string | null;
    productPriceTier: {
      price: number;
    };
  };
}) => {
  const applicableDiscountsWithProductItemDiscount =
    findApplicableContainerDiscounts({
      connectionDiscounts,
      productContainerType: product.containerType,
    })?.map((discount) => {
      if (discount.type === "flat") {
        return {
          discount,
          productItemDiscountAmount: calculateFlatDiscount({
            flatDiscount: discount.discountAmount,
            totalValue: product.productPriceTier.price,
          }),
        };
      }
      return {
        discount,
        productItemDiscountAmount: calculatePercentageDiscount(
          product.productPriceTier.price,
          discount.discountAmount,
        ),
      };
    });

  return applicableDiscountsWithProductItemDiscount?.length
    ? applicableDiscountsWithProductItemDiscount.sort(
        (discountA, discountB) =>
          discountB.productItemDiscountAmount -
          discountA.productItemDiscountAmount,
      )[0]
    : undefined;
};
